const VIEW_PARAM = 'view';
const EVENTS_VIEW_VALUE = 'events';
const EVENT_ID_PARAM = 'eventId';

type OrganizationViewSearch = {
  isEventsView: boolean;
  eventId: string | null;
};

export const parseOrganizationViewSearch = (search: string): OrganizationViewSearch => {
  const params = new URLSearchParams(search);

  return {
    isEventsView: params.get(VIEW_PARAM) === EVENTS_VIEW_VALUE,
    eventId: params.get(EVENT_ID_PARAM),
  };
};

export const buildOrganizationEventsSearch = (eventId?: string | number | null): string => {
  const params = new URLSearchParams();

  params.set(VIEW_PARAM, EVENTS_VIEW_VALUE);

  if (eventId !== null && eventId !== undefined && String(eventId).trim().length > 0) {
    params.set(EVENT_ID_PARAM, String(eventId));
  }

  return `?${params.toString()}`;
};
